import { TooltipTheme } from 'reablocks';

import css from './Tooltip.module.css';

export const tooltipTheme: TooltipTheme = {
  base: css.base,
  disablePointer: css.disablePointer
};
